import styled from 'styled-components';
import EmptyPlaceholder from '@components/common/EmptyPlaceholder';

export const RetryLayer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.9);
`;

export const ErrorHolder = styled.div`
  position: relative;
  top: 10%;
  right: 0;
  left: 0;
  margin: inherit;
  margin-top: .1rem;
  text-align: center;
  font-size: .75rem;
  color: #262626;
  color: #262626;
  z-index: 11;
`;

export const ErrorMessage = styled.div`
  background-color: transparent;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: bold;
  display: flex;
  flex-direction: ${props => props.horizontal ? 'row' : 'column'};
  align-content: space-around;
  justify-content: center;
`;

export const HorizontalMessage = styled.div`
  display: inline-flex;
  position: relative;
  background-color: transparent;
  width: 490px;
  border-radius: 4px;
  font-size: .85rem;
  font-weight:100;
  text-align: center;
`;

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: ${props => props.horizontal ? 'row' : 'column'};
  align-content: space-around;
  align-items: center;
  justify-content: space-around;
  ${props => props.horizontal ?
    `
      .message {
        display: none;
      }
      > div {
        margin: 5px;
      }
    `
    :
    `
      .message {
        position: relative;
        font-size: .85rem;
        font-weight: 100;
        text-align: center;
        width: 250px;
        margin: 5px;
      }
    `
}
`;

export const InfoMessage = styled.div`
  position: relative;
  font-size: .85rem;
  font-weight: 100;
  text-align: center;
  width: 250px;
`;

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  // overflow: hidden;
`;

export const Layer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.5);
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.5);
  width: 100%;
  height: 100%;
  backdrop-filter:blur(2px);
`;

export const Loader = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 2rem;
  margin: auto;
  text-align: center;
  max-width: 300px;
  z-index: 11;
  padding: 10px;
  text-align: center;
  background: rgba(255, 255, 255, 0.5);
  box-shadow: 0 0 10px 10px rgba(255, 255, 255, 0.5);
  border-radius: 50%;
`;

export const NoData = styled(EmptyPlaceholder)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
